import(/* webpackMode: "eager" */ "/vercel/path0/src/app/offline/manito/page.tsx");
